import { __assign } from "tslib";
import TrilogyPrice from '@trilogy-ds/react/lib/components/price/Price';
import React from 'react';
import { ComponentName } from '../enumsComponentsName';
var Price = React.forwardRef(function (props, ref) {
    var splitPrice = function (amount) { return ((props === null || props === void 0 ? void 0 : props.hideCents) ? amount === null || amount === void 0 ? void 0 : amount.toString().split('.')[0] : amount); };
    var period = props.period ? 'par mois' : '';
    var accessibilityLabel = function (props) {
        if (props.accessibilityLabel)
            return props.accessibilityLabel;
        if (props.oldAmount !== undefined && props.amount !== undefined) {
            return "".concat(splitPrice(props.amount), " euros ").concat(period, ", au lieu de ").concat(splitPrice(props.oldAmount), " \u20AC ").concat(period);
        }
        if (props.amount !== undefined) {
            return "".concat(splitPrice(props.amount), " euros ").concat(period);
        }
        if (props.oldAmount !== undefined && props.amount === undefined) {
            return "Ancien prix ".concat(splitPrice(props.oldAmount), " euros ").concat(period);
        }
        return '';
    };
    var priceProps = __assign({ accessibilityLabel: accessibilityLabel(props) }, props);
    return (React.createElement(TrilogyPrice, __assign({}, priceProps, { ref: ref }), props.children));
});
Price.displayName = ComponentName.Price;
export default Price;
//# sourceMappingURL=Price.js.map